export const borders = {
  base: "1px solid var(--chakra-colors-borderColor)",
};
